import * as fe from "@runn/filter-engine"

import { AllowedProjectFilter } from "./filter-engine"

export const splitString = (value: string, lowercase = false): string[] => {
  if (!value) {
    return [""]
  }

  const val = lowercase ? value.toLowerCase() : value

  const formatted = val
    .replace(/['’]/g, "") // remove apostrophes (also the kind that looks weird when pasted)
    .split(/[\s-]+/) // split and also remove dashes

  return formatted
}

export const splitStringLowerCase = (value: string): string[] => {
  return splitString(value, true)
}

type Skill = {
  id: number
  name: string
}

export const filterSkillsByName = (
  skills: ReadonlyArray<Skill>,
  filterValue: string,
): Skill[] => {
  return skills.filter((skill) => {
    if (!filterValue) {
      return true
    }

    const filterWords = splitStringLowerCase(filterValue)
    const skillNameSplit = splitStringLowerCase(skill.name)

    const checkIfWordsIncludeFilter = (val) =>
      skillNameSplit.filter((word) => word.startsWith(val)).length !== 0

    return filterWords.every(checkIfWordsIncludeFilter)
  })
}

// Converts a person project filter to its equivalent project filter
// Returns undefined if the filter is not a person project filter
export const convertToProjectFilter = (
  item: fe.filters.AnyFilter,
): AllowedProjectFilter | undefined => {
  const personToProjectFilterMap = {
    person_membership: "project_id",
  }

  if (personToProjectFilterMap[item.type]) {
    return {
      ...item,
      type: personToProjectFilterMap[item.type],
    } as AllowedProjectFilter
  } else if (item.type.includes("person_project")) {
    return {
      ...item,
      type: item.type.replace("person_project", "project"),
    } as AllowedProjectFilter
  }
}

// Extract the person project filters from the list
// and convert them into project filters
export const convertToProjectFilterList = (
  filter: fe.filters.FilterList<fe.filters.AnyFilter> | fe.filters.AnyFilter,
): fe.filters.FilterList<AllowedProjectFilter> | AllowedProjectFilter => {
  if (fe.filters.isFilterList(filter)) {
    return {
      ...filter,
      items: filter.items.flatMap((item) => {
        if (fe.filters.isFilter(item)) {
          const projectFilter = convertToProjectFilter(item)
          return projectFilter ? [projectFilter] : []
        } else {
          return [convertToProjectFilterList(item)]
        }
      }),
    }
  } else {
    return convertToProjectFilter(filter)
  }
}

export default {
  splitString,
  splitStringLowerCase,
  filterSkillsByName,
}
